export const commitHash = '4e3a450';
export const buildDate = '2026-11-02T23:58:33Z';
export const googleAnalyticsToken = 'G-136F6FE5VJ';
export const environment = 'STAGING';
export const featureFlags = [
  'FEATURE_BENCHMARK_COMPARER',
  'FEATURE_GOROUTINES',
  'FEATURE_BENCHMARK_VISUALIZER',
  'FEATURE_LOG_VISUALIZER',
];
